import { Injectable, Injector } from '@angular/core';
import { EaSubscriptionBuilder as AddressValidation } from '../../ea-subscription-forms/address-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as BirthInfoValidation } from '../../ea-subscription-forms/birth-info-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ChildrenInfoValidation } from '../../ea-subscription-forms/children-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as CivilStateValidation } from '../../ea-subscription-forms/civil-state-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as CompanyProfilValidation } from '../../ea-subscription-forms/company/company-profile-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as CompanySituationComptableValidation } from '../../ea-subscription-forms/company/company-situation-comptable-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as DependentChildrenValidation } from '../../ea-subscription-forms/dependent-children-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ExistingInvestmentsValidation } from '../../ea-subscription-forms/existing-investments-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as HeritageValidation } from '../../ea-subscription-forms/heritage-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as IncomeValidation } from '../../ea-subscription-forms/income-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as RisquesClientPersonneMoraleValidation } from '../../ea-subscription-forms/lcb-ft/risques-client-personne-morale/ea-subscription-form.builder';
import { EaSubscriptionBuilder as RisquesClientPersonnePhysiqueValidation } from '../../ea-subscription-forms/lcb-ft/risques-client-personne-physique/ea-subscription-form.builder';
import { EaSubscriptionBuilder as RisquesDistributionValidation } from '../../ea-subscription-forms/lcb-ft/risques-distribution/ea-subscription-form.builder';
import { EaSubscriptionBuilder as RisquesOperationsValidation } from '../../ea-subscription-forms/lcb-ft/risques-operations/ea-subscription-form.builder';
import { EaSubscriptionBuilder as MailValidation } from '../../ea-subscription-forms/mail/ea-subscription-form.builder';
import { EaSubscriptionBuilder as MaritalStatusValidation } from '../../ea-subscription-forms/marital-status-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as MoneyGamesValidation } from '../../ea-subscription-forms/money-games-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ArbitrageDisinvestmentFormValidation } from '../../ea-subscription-forms/operations-form/arbitrage/arbitrage-disinvestment-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ArbitrageReasonFormValidation } from '../../ea-subscription-forms/operations-form/arbitrage/arbitrage-reason-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ArbitrageTypeFormValidation } from '../../ea-subscription-forms/operations-form/arbitrage/arbitrage-type-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ReinvestmentFluxFormValidation } from '../../ea-subscription-forms/operations-form/arbitrage/reinvestment-flux-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ReinvestmentStockFormValidation } from '../../ea-subscription-forms/operations-form/arbitrage/reinvestment-stock-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as RachatInfoFormValidation } from '../../ea-subscription-forms/operations-form/rachat/ea-subscription-form.builder';
import { EaSubscriptionBuilder as RachatDisinvestmentFormValidation } from '../../ea-subscription-forms/operations-form/rachat/rachat-disinvestment-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as RachatAmountFormValidation } from '../../ea-subscription-forms/operations-form/rachat/rachat-amount-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as RachatPartielTypeFormValidation } from '../../ea-subscription-forms/operations-form/rachat/rachat-partiel-type-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ContractInformationsFormValidation } from '../../ea-subscription-forms/operations-form/shared/contract-informations-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as TransferInfoFormValidation } from '../../ea-subscription-forms/operations-form/transfer/ea-subscription-form.builder';
import { EaSubscriptionBuilder as TransferSupportsFormValidation } from '../../ea-subscription-forms/operations-form/transfer/transfer-supports-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as FiscalityTypeFormValidation } from '../../ea-subscription-forms/operations-form/versements-libres/fiscality-type-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as VersementLibresSupportsFormValidation } from '../../ea-subscription-forms/operations-form/versements-libres/versement-libres-supports-form/ea-subscription-form.builder';
import { FULL_AMOUNT_TOLERANCE } from '../../ea-subscription-forms/operations-form/versements-libres/services/versement-allocation';
import { EaSubscriptionBuilder as VersementAmountFormValidation } from '../../ea-subscription-forms/operations-form/versements-libres/versement-amount-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as VersementsLibresFeesFormValidation } from '../../ea-subscription-forms/operations-form/versements-libres/versements-libres-fees-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as OtherInfoValidation } from '../../ea-subscription-forms/other-info-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as OwnerTaxResidenceValidation } from '../../ea-subscription-forms/owner-tax-residence/ea-subscription-form.builder';
import { EaSubscriptionBuilder as PerSubscriberInfoValidation } from '../../ea-subscription-forms/per/per-subscriber-info/ea-subscription-form.builder';
import { EaSubscriptionBuilder as PersonnesAChargesValidation } from '../../ea-subscription-forms/personnes-a-charges/ea-subscription-form.builder';
import { EaSubscriptionBuilder as PhoneValidation } from '../../ea-subscription-forms/phone-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as PrincipalResidence } from '../../ea-subscription-forms/principal-residence-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ProfessionValidation } from '../../ea-subscription-forms/profession-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as DesiredYieldValidation } from '../../ea-subscription-forms/risk-profil-fifth-part-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as FinancialKnowledgeValidation } from '../../ea-subscription-forms/risk-profil-second-part-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as RiskToleranceValidation } from '../../ea-subscription-forms/risk-profil-third-part-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SpouseInfoValidation } from '../../ea-subscription-forms/spouse-info-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SavingsCapacityValidation } from '../../ea-subscription-forms/savings-capacity-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SavingsRateValidation } from '../../ea-subscription-forms/savings-rate-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as TaxResidencyValidation } from '../../ea-subscription-forms/tax-residency/ea-subscription-form.builder';
import { EaSubscriptionBuilder as NifCodeValidation } from '../../ea-subscription-forms/user-nif-code/ea-subscription-form.builder';
import { EaSubscriptionBuilder as WealthDistributionValidation } from '../../ea-subscription-forms/wealth-distribution-form/ea-subscription-form.builder';
//
import { EaSubscriptionBuilder as SignatureElectronic } from '../../ea-subscription-forms/electronic-signature-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as ExonerationArretTravailValidation } from '../../ea-subscription-forms/exoneration-arret-travail/ea-subscription-form.builder';
import { EaSubscriptionBuilder as FinancialKnowledge7Validation } from '../../ea-subscription-forms/financial-knowledge7-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as FinancialKnowledge8Validation } from '../../ea-subscription-forms/financial-knowledge8-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as FundsInitialPaymentValidation } from '../../ea-subscription-forms/funds-initial-payment-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as FundsInitialPaymentScpiValidation } from '../../ea-subscription-forms/funds-initial-payment-scpi-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as GarantiePlancherValidation } from '../../ea-subscription-forms/garantie-plancher/ea-subscription-form.builder';
import { EaSubscriptionBuilder as InvestissementProgressifTable } from '../../ea-subscription-forms/investissement-progressif-table/ea-subscription-form.builder';
import { EaSubscriptionBuilder as InvestissementSupportFormValidation } from '../../ea-subscription-forms/investissement-support-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as InvestmentAllocationValidation } from '../../ea-subscription-forms/investment-allocation-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as InvestmentAmountDurationValidation } from '../../ea-subscription-forms/investment-amount-duration-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as InvestmentDuration } from '../../ea-subscription-forms/investment-period-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as OptionConfigurationValidation } from '../../ea-subscription-forms/option-configuration/ea-subscription-form.builder';
import { EaSubscriptionBuilder as PaiementPrimesValidation } from '../../ea-subscription-forms/payment-primes/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SecurisationMoinsValues } from '../../ea-subscription-forms/securisation-moins-values-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SecurisationPlus } from '../../ea-subscription-forms/securisation-plus-values-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SubscribeInLifeValidation } from '../../ea-subscription-forms/subscribe-in-life/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SwisslifeGestionFinanciereValidation } from '../../ea-subscription-forms/swisslife-gestion-financiere/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SwisslifeRenonceProfilValidation } from '../../ea-subscription-forms/swisslife-renonce-profil/ea-subscription-form.builder';

import { EaSubscriptionBuilder as contigencyGarantiesForm } from '../../ea-subscription-forms/contigency/contigency-garanties/ea-subscription-form.builder';
import { EaSubscriptionBuilder as contigencyInformationsForm } from '../../ea-subscription-forms/contigency/contigency-informations/ea-subscription-form.builder';
import { EaSubscriptionBuilder as contigencyMaintainIncomeForm } from '../../ea-subscription-forms/contigency/contigency-maintain-income/ea-subscription-form.builder';
import { EaSubscriptionBuilder as contigencyProtectLovedForm } from '../../ea-subscription-forms/contigency/contigency-protect-loved/ea-subscription-form.builder';
import { EaSubscriptionBuilder as contigencyRegimeProfessionForm } from '../../ea-subscription-forms/contigency/contigency-regime-profession/ea-subscription-form.builder';
import { EaSubscriptionBuilder as swisslifePrevoyanceForm } from '../../ea-subscription-forms/contigency/swisslife-prevoyance/ea-subscription-form.builder';
import { EaSubscriptionBuilder as crowdfundingAmountForm } from '../../ea-subscription-forms/crowdfunding/crowdfunding-amount/ea-subscription-form.builder';
import { EaSubscriptionBuilder as crowdfundingSettings2Form } from '../../ea-subscription-forms/crowdfunding/crowdfunding-settings2/ea-subscription-form.builder';
import { EaSubscriptionBuilder as fcpiSettingsForm } from '../../ea-subscription-forms/fcpi/fcpi-setting/ea-subscription-form.builder';
import { EaSubscriptionBuilder as fcpiSettings2Form } from '../../ea-subscription-forms/fcpi/fcpi-setting2/ea-subscription-form.builder';
import { EaSubscriptionBuilder as gfiGffNbPartsForm } from '../../ea-subscription-forms/gfi-gff/gfi-gff-nb-parts/ea-subscription-form.builder';
import { EaSubscriptionBuilder as gfvAlreadyAssociateOfProductForm } from '../../ea-subscription-forms/gfv/gfv-already-associate-of-product/ea-subscription-form.builder';
import { EaSubscriptionBuilder as gfvNbPartsForm } from '../../ea-subscription-forms/gfv/gfv-nb-parts/ea-subscription-form.builder';
import { EaSubscriptionBuilder as girardiAmountForm } from '../../ea-subscription-forms/girardi-amount/ea-subscription-form.builder';
import { EaSubscriptionBuilder as insuranceGarantiesForm } from '../../ea-subscription-forms/insurance/insurance-garanties/ea-subscription-form.builder';
import { EaSubscriptionBuilder as insuranceHypothesesForm } from '../../ea-subscription-forms/insurance/insurance-hypotheses/ea-subscription-form.builder';
import { EaSubscriptionBuilder as insuranceInformationsForm } from '../../ea-subscription-forms/insurance/insurance-informations/ea-subscription-form.builder';
import { EaSubscriptionBuilder as loanRepartitionForm } from '../../ea-subscription-forms/loan-repartition-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as peePercoFeesForm } from '../../ea-subscription-forms/pee-perco-fees-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as rcdaComparaisonProductsForm } from '../../ea-subscription-forms/rcda-comparaison-products/ea-subscription-form.builder';
import { EaSubscriptionBuilder as rcdaDevisSelectionForm } from '../../ea-subscription-forms/rcda-devis-selection/ea-subscription-form.builder';
import { EaSubscriptionBuilder as realEstateCharacteristicsCristalisForm } from '../../ea-subscription-forms/real-estate/real-estate-characteristics-cristalis/ea-subscription-form.builder';
import { EaSubscriptionBuilder as realEstateFiscalLawForm } from '../../ea-subscription-forms/real-estate/real-estate-fiscal-law/ea-subscription-form.builder';
import { EaSubscriptionBuilder as realEstateInvestmentAmountForm } from '../../ea-subscription-forms/real-estate/real-estate-investment-amount/ea-subscription-form.builder';
import { EaSubscriptionBuilder as scpiAlreadyClientOfProductForm } from '../../ea-subscription-forms/scpi/scpi-already-client-of-product/ea-subscription-form.builder';
import { EaSubscriptionBuilder as scpiDividentForm } from '../../ea-subscription-forms/scpi/scpi-divident/ea-subscription-form.builder';
import { EaSubscriptionBuilder as scpiKnowledgeForm } from '../../ea-subscription-forms/scpi/scpi-knowledge/ea-subscription-form.builder';
import { EaSubscriptionBuilder as scpiPledgesOfSharesForm } from '../../ea-subscription-forms/scpi/scpi-pledge-of-shares/ea-subscription-form.builder';
import { EaSubscriptionBuilder as scpiScheduledPaymentForm } from '../../ea-subscription-forms/scpi/scpi-scheduled-payment/ea-subscription-form.builder';

import { EaSubscriptionBuilder as DeplacementTravailHauteurValidation } from '../../ea-subscription-forms/profil-emprunteur/deplacement-travail-hauteur-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as OptionsEmprunteurFormValidation } from '../../ea-subscription-forms/profil-emprunteur/options-emprunteur-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SmokerFormValidation } from '../../ea-subscription-forms/profil-emprunteur/smoker-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as SportDeplacementsFormValidation } from '../../ea-subscription-forms/profil-emprunteur/sport-deplacements-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as TravailManuelFormValidation } from '../../ea-subscription-forms/profil-emprunteur/travail-manuel-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as TravailRisqueFormValidation } from '../../ea-subscription-forms/profil-emprunteur/travail-risque-form/ea-subscription-form.builder';
import { EaSubscriptionBuilder as JointOwnershipValidation } from '../../ea-subscription-forms/service-delivery/joint-ownership/ea-subscription-form.builder';

import { EaSubscriptionBuilder as creditAdditionnalInformationsForm } from '../../ea-subscription-forms/credit-form/credit-additionnal-informations/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditDiffereForm } from '../../ea-subscription-forms/credit-form/credit-differe/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditGeneralInformationsForm } from '../../ea-subscription-forms/credit-form/credit-general-informations/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditGuaranteesForm } from '../../ea-subscription-forms/credit-form/credit-guarantees/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditInformationsForm } from '../../ea-subscription-forms/credit-form/credit-informations/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditInsuranceQuotiteForm } from '../../ea-subscription-forms/credit-form/credit-insurance-quotite/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditManualTarificationForm } from '../../ea-subscription-forms/credit-form/credit-manual-tarification/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditOptionTarificationForm } from '../../ea-subscription-forms/credit-form/credit-option-tarification/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditOutstandingsForm } from '../../ea-subscription-forms/credit-form/credit-outstandings/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditOwnersProfessionDetailsForm } from '../../ea-subscription-forms/credit-form/credit-owners-profession-details/ea-subscription-form.builder';
import { EaSubscriptionBuilder as creditTarificationForm } from '../../ea-subscription-forms/credit-form/credit-tarification/ea-subscription-form.builder';

import { UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { ProductsTypeEnum } from '@app/forms/subscription/definition/interface';
import {
  Owner,
  Parameters,
  PledgeIban,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import * as _ from 'lodash';
import { EaSubscriptionBuilder as JointOwnershipForm } from '../../ea-subscription-forms/service-delivery/joint-ownership/ea-subscription-form.builder';
import { EaSubscriptionBuilder as userNifCodeForm } from '../../ea-subscription-forms/user-nif-code/ea-subscription-form.builder';

@Injectable({
  providedIn: 'root',
})
export class ValidationBridgeService {
  cristalisOrganizationId: number = 251251251;
  isCristalisOrganization: boolean;
  constructor(
    private injector: Injector,
    private attributionDao: AttributionDao,
  ) {
    this.attributionDao.getOrganization().subscribe((data: any) => {
      this.isCristalisOrganization = this.cristalisOrganizationId === data.id;
    });
  }

  getMail(entity) {
    return this.injector.get(MailValidation).generate(entity, {}).valid;
  }
  isValidOwnerForGirardin(owner: Owner): boolean {
    const {
      userFatherLastName,
      userFatherFirstName,
      userMotherLastName,
      userMotherFirstName,
      // userSocialRegime,
      // userSocialSecurityNumber,
    } = owner || {};

    return (
      !!userFatherLastName &&
      !!userFatherFirstName &&
      !!userMotherLastName &&
      !!userMotherFirstName
      // &&
      // !!userSocialRegime &&
      // !!userSocialSecurityNumber
    );
  }
  isCivilStateValid(
    entity: any,
    productType: ProductsTypeEnum,
    user?: UserAuthentified,
  ): boolean {
    const civilStateValidation = this.injector.get(CivilStateValidation);

    return civilStateValidation.generate(entity, {
      productType,
      sessionConsultant: !!user?.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
      pledgeParameters: entity?.parameters || {},
      hasSwisslifeProduct: (entity?.products || []).some(
        (product: any) => product?.parameters?.partnerFlux === 'SWISSLIFE',
      ),
    }).valid;
  }
  isValidOwnerForFinancialAssets(owner: Owner): boolean {
    return !!owner?.userSocialRegime && !!owner?.userSocialSecurityNumber;
  }
  getCivilState(entity: PledgeRead, user?: UserAuthentified) {
    const productType = entity?.productType;
    const owner = entity?.owners?.[0];
    if (productType === ProductsTypeEnum.GIRARDIN) {
      return (
        this.isValidOwnerForGirardin(owner) &&
        this.isCivilStateValid(entity as any, productType, user)
      );
    } else if (
      productType === ProductsTypeEnum.ASSURANCE_VIE ||
      productType === ProductsTypeEnum.CONTRAT_CAPI ||
      productType === ProductsTypeEnum.COMPTE_TITRE ||
      productType === ProductsTypeEnum.PEA ||
      productType === ProductsTypeEnum.PEI ||
      productType === ProductsTypeEnum.PEE ||
      productType === ProductsTypeEnum.PERCO ||
      productType === ProductsTypeEnum.PER ||
      productType === ProductsTypeEnum.PRESTATION
    ) {
      return (
        // this.isValidOwnerForFinancialAssets(owner) &&
        this.isCivilStateValid(entity as any, productType, user)
      );
    }
    return this.isCivilStateValid(
      entity as any,
      productType as ProductsTypeEnum,
      user,
    );
  }
  getCompanyProfile(entity) {
    return this.injector.get(CompanyProfilValidation).generate(entity, {})
      .valid;
  }
  getChildrenForm(entity) {
    return this.injector.get(ChildrenInfoValidation).generate(entity, {}).valid;
  }
  getBirthInfo(entity, user?: UserAuthentified) {
    return this.injector.get(BirthInfoValidation).generate(entity, {
      sessionConsultant: !!user?.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
    }).valid;
  }

  getPerSubscriberInfo(entity) {
    const parameters = entity?.parameters || {};
    return this.injector.get(PerSubscriberInfoValidation).generate(entity, {
      ...parameters,
    }).valid;
  }

  getAddress(entity) {
    return this.injector.get(AddressValidation).generate(entity, {}).valid;
  }
  getNifCode(entity, user) {
    return this.injector.get(NifCodeValidation).generate(entity, {
      sessionConsultant: !!user?.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
    }).valid;
  }
  getTaxResidency(entity) {
    return this.injector.get(TaxResidencyValidation).generate(entity, {}).valid;
  }
  getOwnerTaxResidence(entity) {
    return this.injector.get(OwnerTaxResidenceValidation).generate(entity, {})
      .valid;
  }
  getPhone(entity, user) {
    return this.injector.get(PhoneValidation).generate(entity, {
      sessionConsultant: !!user?.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
    }).valid;
  }

  getOtherInfo(entity) {
    return this.injector.get(OtherInfoValidation).generate(entity, {}).valid;
  }
  getUserNifCode(entity, user) {
    return this.injector.get(userNifCodeForm).generate(entity, {
      sessionConsultant: !!user?.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
      productType: entity?.productType,
    }).valid;
  }
  getCompanyProfil(entity, user: UserAuthentified) {
    return this.injector.get(CompanyProfilValidation).generate(entity, {
      sessionConsultant: !!user?.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
    }).valid;
  }
  getCompanySituationComptable(entity, user: UserAuthentified) {
    return this.injector
      .get(CompanySituationComptableValidation)
      .generate(entity, {}).valid;
  }
  getMaritalStatus(entity, user?: UserAuthentified) {
    return this.injector.get(MaritalStatusValidation).generate(entity, {
      sessionConsultant: !!user?.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
      productType: entity?.productType,
    }).valid;
  }
  getSpouseInfo(entity) {
    return this.injector.get(SpouseInfoValidation).generate(entity, {}).valid;
  }
  getDependentChildren(entity) {
    return this.injector.get(DependentChildrenValidation).generate(entity, {})
      .valid;
  }
  getPersonnesACharges(entity) {
    return this.injector.get(PersonnesAChargesValidation).generate(entity, {})
      .valid;
  }
  getIncome(entity) {
    return this.injector.get(IncomeValidation).generate(entity, {}).valid;
  }
  getProfession(entity, organization) {
    return this.injector.get(ProfessionValidation).generate(entity, {
      organizationId: organization?.id,
      pledgeParameters: entity?.parameters || {},
    }).valid;
  }
  getHeritage(entity) {
    return this.injector.get(HeritageValidation).generate(entity, {}).valid;
  }
  getWealthDistribution(entity) {
    return this.injector.get(WealthDistributionValidation).generate(entity, {})
      .valid;
  }
  getPrincipalResidence(entity) {
    return this.injector.get(PrincipalResidence).generate(entity, {}).valid;
  }
  getRisquesOperations(entity) {
    return this.injector.get(RisquesOperationsValidation).generate(entity)
      .valid;
  }
  getRisquesDistribution(entity) {
    return this.injector.get(RisquesDistributionValidation).generate(entity)
      .valid;
  }
  getRisquesClientPersonneMorale(entity) {
    return this.injector
      .get(RisquesClientPersonneMoraleValidation)
      .generate(entity?.owners, entity?.accountId).valid;
  }
  getRisquesClientPersonnePhysique(entity) {
    return this.injector
      .get(RisquesClientPersonnePhysiqueValidation)
      .generate(entity?.owners, entity.accountId).valid;
  }
  getSavingsCapacity(entity: PledgeRead) {
    return this.injector
      .get(SavingsCapacityValidation)
      .generate(entity, { ...(entity?.parameters || {}) }).valid;
  }
  getInvestmentObjective(entity: PledgeRead) {
    return entity?.parameters?.investmentGoals?.length > 0;
    // return this.injector.get(InvestmentObjective).generate(entity).valid;
  }

  getFinancialKnowledge(entity: PledgeRead) {
    const productType = entity?.productType;
    return this.injector
      .get(FinancialKnowledgeValidation)
      .generate(entity as any, { productType }).valid;
  }
  getScpiKnowledge(entity) {
    return this.injector.get(scpiKnowledgeForm).generate(entity, {}).valid;
  }
  getArbitrageType(entity) {
    return this.injector.get(ArbitrageTypeFormValidation).generate(entity, {})
      .valid;
  }
  getArbitrageReason(entity) {
    return this.injector.get(ArbitrageReasonFormValidation).generate(entity, {})
      .valid;
  }
  getVersementAmountForm(entity) {
    return this.injector.get(VersementAmountFormValidation).generate(entity, {})
      .valid;
  }
  getVersementsLibresFeesForm(entity) {
    return this.injector
      .get(VersementsLibresFeesFormValidation)
      .generate(entity, {}).valid;
  }
  getFiscalityTypeForm(entity) {
    return this.injector.get(FiscalityTypeFormValidation).generate(entity, {})
      .valid;
  }
  getArbitrageDisinvestmentForm(entity) {
    return this.injector
      .get(ArbitrageDisinvestmentFormValidation)
      .generate(entity, {}).valid;
  }
  getRachatDisinvestmentForm(entity) {
    return this.injector
      .get(RachatDisinvestmentFormValidation)
      .generate(entity, {}).valid;
  }
  getRachatAmountForm(entity) {
    return this.injector.get(RachatAmountFormValidation).generate(entity, {})
      .valid;
  }
  getRachatProgrammedDisinvestmentForm(entity) {
    return this.injector
      .get(RachatDisinvestmentFormValidation)
      .generate(entity, { programmed: true }).valid;
  }
  getRachatProgrammedAmountForm(entity) {
    return this.injector
      .get(RachatAmountFormValidation)
      .generate(entity, { programmed: true }).valid;
  }
  getRachatPartielTypeForm(entity) {
    return this.injector
      .get(RachatPartielTypeFormValidation)
      .generate(entity, {}).valid;
  }
  getReinvestmentStockForm(entity) {
    return this.injector
      .get(ReinvestmentStockFormValidation)
      .generate(entity, {}).valid;
  }
  getVersementLibresSupportsAllocation(entity: PledgeRead) {
    const parameters = entity?.products?.[0]?.parameters;
    const lines = parameters?.supportsInvestment?.supportRepartition || [];
    if (!lines.length) return false;

    const allocated = lines.reduce(
      (sum, line) => sum + (Number(line?.amount) || 0),
      0,
    );

    const versementAmount = [
      'VERSEMENT_COMPLEMENTAIRE',
      'VERSEMENT_PROGRAMME',
    ].includes(entity?.operation)
      ? Number(parameters?.supportsInvestment?.totalAmount) || 0
      : 0;
    if (versementAmount > 0) {
      return Math.abs(allocated - versementAmount) <= FULL_AMOUNT_TOLERANCE;
    }

    return allocated > 0;
  }

  getVersementLibresSupportsForm(entity) {
    return this.injector
      .get(VersementLibresSupportsFormValidation)
      .generate(entity, {}).valid;
  }
  getTransferSupportsForm(entity) {
    return this.injector
      .get(TransferSupportsFormValidation)
      .generate(entity, {}).valid;
  }
  getReinvestmentFluxForm(entity) {
    return this.injector
      .get(ReinvestmentFluxFormValidation)
      .generate(entity, {}).valid;
  }
  getContractInformations(entity) {
    return this.injector
      .get(ContractInformationsFormValidation)
      .generate(entity, {}).valid;
  }
  getTransferInfo(entity) {
    return this.injector.get(TransferInfoFormValidation).generate(entity, {})
      .valid;
  }
  getRachatInfo(entity) {
    return this.injector.get(RachatInfoFormValidation).generate(entity, {})
      .valid;
  }
  getSavingsRate(entity) {
    return this.injector.get(SavingsRateValidation).generate(entity, {}).valid;
  }
  getSmoker(entity) {
    return this.injector.get(SmokerFormValidation).generate(entity, {}).valid;
  }
  getDeplacementTravailHauteur(entity) {
    return this.injector
      .get(DeplacementTravailHauteurValidation)
      .generate(entity, {}).valid;
  }
  getTravailManuel(entity) {
    return this.injector.get(TravailManuelFormValidation).generate(entity, {})
      .valid;
  }
  getTravailRisque(entity) {
    return this.injector.get(TravailRisqueFormValidation).generate(entity, {})
      .valid;
  }
  getSportDeplacements(entity) {
    return this.injector
      .get(SportDeplacementsFormValidation)
      .generate(entity, {}).valid;
  }
  getOptionsEmprunteur(entity) {
    return this.injector
      .get(OptionsEmprunteurFormValidation)
      .generate(entity, {}).valid;
  }
  getRiskTolerance(entity) {
    return this.injector.get(RiskToleranceValidation).generate(entity, {})
      .valid;
  }
  getDesiredYield(entity) {
    return this.injector.get(DesiredYieldValidation).generate(entity, {}).valid;
  }
  getExistingInvestments(entity) {
    return this.injector.get(ExistingInvestmentsValidation).generate(entity, {})
      .valid;
  }
  getMoneyGames(entity) {
    return this.injector.get(MoneyGamesValidation).generate(entity, {}).valid;
  }
  getInvestmentKnowledge(entity) {
    // return this.injector.get(InvestmentKnowledgeValidation).generate(entity, {})
    //   .valid;
    const keys = [
      'knowBond',
      'knowMonetaryProduct',
      'knowPrivateEquity',
      'knowScpi',
      'knowStock',
      'knowIndexFund',
      'knowDerivativeproduct',
    ];
    const result = this.oneValueRequiredOwners(entity, keys);

    return result;
  }
  public oneValueRequired(keys): ValidatorFn {
    return (formGroup: UntypedFormGroup) => {
      const isOneValueRequired = keys.some(key => {
        let value;
        if (formGroup.value instanceof Array) {
          value = formGroup.value.some(el => {
            return el[key] !== 'UNKNOWN';
          });
        } else {
          value = formGroup?.value?.owners.some(el => el[key] !== 'UNKNOWN');
        }

        return value;
      });
      if (isOneValueRequired) {
        return null;
      }
      return { oneValueRequired: true };
    };
  }
  private oneValueRequiredOwners(pledge: PledgeRead, keys: string[]): boolean {
    let isValid = false;
    pledge?.owners.forEach(owner => {
      const isOneValueRequired = keys.some(key => {
        return owner?.riskProfil?.[key];
      });
      if (!isOneValueRequired) {
        isValid = false;
      } else {
        isValid = true;
      }
    });
    return isValid;
  }

  getFinancialKnowledge1(entity) {
    const keys = ['monetaryProduct1', 'monetaryProduct2', 'bond1', 'bond2'];

    return this.oneValueRequiredOwners(entity, keys);
  }
  getFinancialKnowledge2(entity) {
    const keys = ['stock1', 'stock2', 'privateEquity1', 'privateEquity2'];
    return this.oneValueRequiredOwners(entity, keys);
  }
  getFinancialKnowledge3(entity) {
    const keys = [
      'indexFund1',
      'indexFund2',
      'derivativeProducts1',
      'derivativeProducts2',
    ];
    return this.oneValueRequiredOwners(entity, keys);
  }
  getFinancialKnowledge4(entity) {
    const keys = ['scpi1', 'scpi2', 'scpi3'];
    return this.oneValueRequiredOwners(entity, keys);
  }
  getFinancialKnowledge7(entity) {
    return this.injector.get(FinancialKnowledge7Validation).generate(entity, {})
      .valid;
  }
  getFinancialKnowledge8(entity) {
    return this.injector.get(FinancialKnowledge8Validation).generate(entity, {})
      .valid;
  }

  getInvest(entity: PledgeRead) {
    const { avInvestmentType, avMonthlyPayment, avInitialPayment } =
      entity?.products?.[0]?.parameters || {};
    if (avInvestmentType === 'INITIAL' && avInitialPayment > 0) return true;

    if (avInvestmentType === 'MONTHLY' && avMonthlyPayment > 0) return true;

    if (
      avInvestmentType === 'INITIAL_AND_MONTHLY' &&
      avInitialPayment > 0 &&
      avMonthlyPayment > 0
    )
      return true;

    return false;
  }

  getIndivisaire(entity: any, user?: UserAuthentified) {
    return this.injector
      .get(JointOwnershipForm)
      .generate(entity, { sessionConsultant: !!user?.sessionConsultant }).valid;
  }

  getInvestmentDuration(entity) {
    return this.injector.get(InvestmentDuration).generate(entity).valid;
  }
  getSubscribeInLife(entity) {
    return this.injector.get(SubscribeInLifeValidation).generate(entity).valid;
  }
  getFundsInitialPayment(entity) {
    const { products = [] } = entity || {};
    const mainProduct = !!products.length ? products[0] : {};

    const allProductsHasFundsOrigin = products?.every(
      ({ parameters }) => !!parameters?.fundsOriginList?.length,
    );

    return (
      allProductsHasFundsOrigin &&
      this.injector.get(FundsInitialPaymentValidation).generateForm(mainProduct)
        .valid
    );
  }
  getFundsInitialPaymentScpi(entity) {
    const { products = [] } = entity || {};
    const allProductsHasFundsOrigin = products?.every(
      ({ parameters }) => !!parameters?.fundsOriginList?.length,
    );
    return (
      allProductsHasFundsOrigin &&
      this.injector
        .get(FundsInitialPaymentScpiValidation)
        .generate(entity?.products || []).valid
    );
  }
  getJointOwnership(entity) {
    return this.injector.get(JointOwnershipValidation).generate(entity, {})
      .valid;
  }
  getScpiDividentForm(entity) {
    return this.injector.get(scpiDividentForm).generate(entity).valid;
  }
  getScpiPledgeOfShares(entity) {
    return this.injector.get(scpiPledgesOfSharesForm).generate(entity).valid;
  }
  getScpiAlreadyClientOfProduct(entity) {
    return this.injector
      .get(scpiAlreadyClientOfProductForm)
      .generate(entity?.products || []).valid;
  }
  getRealEstateInvestmentAmountForm(entity) {
    const { products = [] } = entity || {};
    const mainProduct = !!products.length ? products[0] : {};
    return this.injector
      .get(realEstateInvestmentAmountForm)
      .generateForm(mainProduct, {}).valid;
  }
  getRcdaComparaisonProducts(entity) {
    return this.injector.get(rcdaComparaisonProductsForm).generate(entity)
      .valid;
  }
  getRcdaDevisSelection(entity) {
    return this.injector.get(rcdaDevisSelectionForm).generate(entity, {}).valid;
  }
  getSwisslifePrevoyance(entity) {
    return this.injector.get(swisslifePrevoyanceForm).generate(entity, {})
      .valid;
  }
  getContigencyInformations(entity) {
    return this.injector.get(contigencyInformationsForm).generate(entity, {})
      .valid;
  }
  getContigencyProtectLoved(entity) {
    return this.injector.get(contigencyProtectLovedForm).generate(entity, {})
      .valid;
  }
  getContigencyMaintainIncome(entity) {
    return this.injector.get(contigencyMaintainIncomeForm).generate(entity, {})
      .valid;
  }
  getContigencyGaranties(entity) {
    return this.injector.get(contigencyGarantiesForm).generate(entity, {})
      .valid;
  }
  getContigencyRegimeProfession(entity) {
    return this.injector
      .get(contigencyRegimeProfessionForm)
      .generate(entity, {}).valid;
  }
  getInsuranceHypotheses(entity) {
    return this.injector.get(insuranceHypothesesForm).generate(entity, {})
      .valid;
  }
  getInsuranceInformations(entity) {
    return this.injector.get(insuranceInformationsForm).generate(entity, {})
      .valid;
  }
  getInsuranceGaranties(entity) {
    return this.injector.get(insuranceGarantiesForm).generate(entity, {}).valid;
  }
  getPeePercoFeesForm(entity) {
    return this.injector.get(peePercoFeesForm).generate(entity, {}).valid;
  }
  getGfvAlreadyAssociateOfProduct(entity) {
    return this.injector
      .get(gfvAlreadyAssociateOfProductForm)
      .generate(entity, {}).valid;
  }
  getGfvNbParts(entity) {
    return this.injector.get(gfvNbPartsForm).generate(entity, {}).valid;
  }
  getRealEstateFiscalLaw(entity) {
    return this.injector.get(realEstateFiscalLawForm).generate(entity, {})
      .valid;
  }
  getCreditGeneralInformations(entity) {
    return this.injector.get(creditGeneralInformationsForm).generate(entity, {})
      .valid;
  }
  getCreditInformations(entity) {
    return this.injector.get(creditInformationsForm).generate(entity, {}).valid;
  }
  getCreditDiffere(entity) {
    return this.injector.get(creditDiffereForm).generate(entity, {}).valid;
  }
  getCreditInsuranceQuotite(entity) {
    return this.injector.get(creditInsuranceQuotiteForm).generate(entity, {})
      .valid;
  }
  getCreditGuarantees(entity) {
    return this.injector.get(creditGuaranteesForm).generate(entity, {}).valid;
  }
  getCreditOptionTarification(entity) {
    return this.injector.get(creditOptionTarificationForm).generate(entity, {})
      .valid;
  }
  getOwnersProfessionDetails(entity) {
    return this.injector
      .get(creditOwnersProfessionDetailsForm)
      .generate(entity, {}).valid;
  }
  getCreditManualTarification(entity) {
    return this.injector.get(creditManualTarificationForm).generate(entity, {})
      .valid;
  }
  getCreditOutstandings(entity) {
    return this.injector.get(creditOutstandingsForm).generate(entity, {}).valid;
  }
  getCreditTarification(entity) {
    return this.injector.get(creditTarificationForm).generate(entity, {}).valid;
  }
  getCreditAdditionnalInformations(entity) {
    return this.injector
      .get(creditAdditionnalInformationsForm)
      .generate(entity, {}).valid;
  }
  getGfiGffNbParts(entity) {
    return this.injector.get(gfiGffNbPartsForm).generate(entity, {}).valid;
  }
  getScpiScheduledPaymentForm(entity) {
    return this.injector.get(scpiScheduledPaymentForm).generate(entity).valid;
  }
  getInvestmentAllocation(entity) {
    return this.injector
      .get(InvestmentAllocationValidation)
      .generate(entity, {}).valid;
  }
  //
  getSupport(entity: PledgeRead) {
    return (
      entity?.products?.[0] &&
      entity?.products?.[0]?.parameters?.supportRepartition?.length > 0
    );
  }
  getIsinTable(entity: PledgeRead) {
    const product = entity?.products?.[0];
    if (!product) return false;

    const supportRepartition = product?.parameters?.supportRepartition;
    if (!supportRepartition?.length) return false;

    const avInvestmentType = product?.parameters?.avInvestmentType;
    const TOLERANCE = 0.01;

    const checkInitial = ['INITIAL', 'INITIAL_AND_MONTHLY'].includes(
      avInvestmentType,
    );
    const checkMonthly = ['MONTHLY', 'INITIAL_AND_MONTHLY'].includes(
      avInvestmentType,
    );

    if (!checkInitial && !checkMonthly) return false;

    if (checkInitial) {
      const initialSum = supportRepartition.reduce(
        (sum, s) => sum + (s.initalRepartition || 0),
        0,
      );
      if (Math.abs(initialSum - 1) > TOLERANCE) return false;
    }

    if (checkMonthly) {
      const monthlySum = supportRepartition.reduce(
        (sum, s) => sum + (s.monthlyRepartition || 0),
        0,
      );
      if (Math.abs(monthlySum - 1) > TOLERANCE) return false;
    }

    return true;
  }

  getInvestmentAmountDuration(entity) {
    return this.injector
      .get(InvestmentAmountDurationValidation)
      .generate(entity, {}).valid;
  }

  getInvestissementSupportForm(entity) {
    return this.injector
      .get(InvestissementSupportFormValidation)
      .generate(entity, {}).valid;
  }
  getOptionConfiguration(entity) {
    return this.injector.get(OptionConfigurationValidation).generate(entity, {})
      .valid;
  }
  //
  getInvestissementProgressifTable(entity) {
    return this.injector.get(InvestissementProgressifTable).generate(entity, {})
      .valid;
  }
  getSecurisationPlus(entity) {
    return this.injector.get(SecurisationPlus).generate(entity, {}).valid;
  }
  getSecurisationMoinsValues(entity) {
    return this.injector.get(SecurisationMoinsValues).generate(entity, {})
      .valid;
  }
  getPaymentPrimes(entity) {
    return this.injector.get(PaiementPrimesValidation).generate(entity).valid;
  }
  getGarantiePlancher(entity) {
    return this.injector.get(GarantiePlancherValidation).generate(entity, {})
      .valid;
  }
  getExonerationArretTravail(entity) {
    return this.injector
      .get(ExonerationArretTravailValidation)
      .generate(entity, {}).valid;
  }
  getSwisslifeRenonceProfil(entity) {
    return this.injector
      .get(SwisslifeRenonceProfilValidation)
      .generate(entity, {}).valid;
  }
  getSwisslifeGestionFinanciere(entity) {
    return this.injector
      .get(SwisslifeGestionFinanciereValidation)
      .generate(entity).valid;
  }
  getBeneficiary(entity: PledgeRead) {
    const { avClauseBeneficiaire, avClauseBeneficiaireStandard } =
      entity?.products?.[0]?.parameters || {};

    if (!avClauseBeneficiaire) return false;

    if (avClauseBeneficiaire === 'STANDARD' && !avClauseBeneficiaireStandard)
      return false;

    return true;
  }
  getRentPaymentForm(entity: PledgeRead) {
    const { parameters = {} as Parameters } = entity || {};
    const { scpiRentPaymentIban = {} as PledgeIban } = parameters || {};
    const { iban, bic, holder, bankName } = scpiRentPaymentIban || {};
    return [!!iban, !!bic, !!holder, !!bankName].every(Boolean);
  }
  public paymentFormValidation(entity: PledgeRead): boolean {
    const {
      paymentType,
      holderIsSubscriber,
      directDebitIban,
      reltionshipHolderSubscriber,
      interventionReason,
    } = entity?.products?.[0]?.parameters || {};
    const { iban, bic, holder } = directDebitIban || {};
    if (!paymentType) return false;
    if (paymentType === 'DIRECT_DEBIT') {
      if (!holder || !bic || !iban) {
        return false;
      }
    }

    if (holderIsSubscriber === false || !holderIsSubscriber) {
      if (!reltionshipHolderSubscriber || !interventionReason) {
        return false;
      }
    }
    return true;
  }
  public paymentFormValidationForCristalis(entity: PledgeRead): boolean {
    const {
      paymentType,
      holderIsSubscriber,

      directDebitIban,
      reltionshipHolderSubscriber,
      interventionReason,
    } = entity?.products?.[0]?.parameters || {};
    const { iban, bic, holder } = directDebitIban || {};
    if (!paymentType) return false;
    if (paymentType === 'DIRECT_DEBIT') {
      if (!holder || !bic || !iban) {
        return false;
      }
    }

    if (holderIsSubscriber === false || !holderIsSubscriber) {
      if (!reltionshipHolderSubscriber || !interventionReason) {
        return false;
      }
    }
    return true;
  }

  getPaymentForm(entity: PledgeRead) {
    return this.paymentFormValidation(entity);
  }
  getGirardiAmountForm(entity) {
    return this.injector
      .get(girardiAmountForm)
      .generate(entity, { ...entity?.parameters }).valid;
  }
  getCrowdfundingAmountForm(entity: PledgeRead) {
    return this.injector
      .get(crowdfundingAmountForm)
      .generate(entity, { ...entity?.parameters }).valid;
  }
  getCrowdfundingSettings2Form(entity: PledgeRead) {
    return this.injector
      .get(crowdfundingSettings2Form)
      .generate(entity, { ...entity?.parameters }).valid;
  }
  getFcpiSettingsForm(entity: PledgeRead) {
    return this.injector
      .get(fcpiSettingsForm)
      .generate(entity, { ...entity?.parameters }).valid;
  }
  getFcpiSettings2Form(entity: PledgeRead) {
    return this.injector
      .get(fcpiSettings2Form)
      .generate(entity, { ...entity?.parameters }).valid;
  }
  getCrowdfundingFee(pledge: PledgeRead) {
    const feeQ = pledge?.parameters?.additionalQuestions?.find(
      q => q.id == CompanyFieldType.CROWDFUNDING_FEES,
    );
    const includeFeeQ = pledge?.parameters?.additionalQuestions?.find(
      q =>
        q.id ==
        CompanyFieldType.CROWDFUNDING_INCLUDE_FEES_IN_SUBSCRIPTION_AMOUNT,
    );
    const { crowdfundingFees, crowdfundingIncludeFeesInSubscriptionAmount } =
      pledge?.products?.[0]?.parameters || {};
    if (feeQ && includeFeeQ)
      return (
        !!crowdfundingFees &&
        crowdfundingIncludeFeesInSubscriptionAmount != null
      );
    if (feeQ) return !!crowdfundingFees;
    if (includeFeeQ) return crowdfundingIncludeFeesInSubscriptionAmount != null;

    return true;
  }

  getLoanRepartitionForm = (entity: PledgeRead) => {
    return this.injector.get(loanRepartitionForm).generate(entity).valid;
  };
  getRealEstateCharacteristics = (entity, user) => {
    return this.injector
      .get(realEstateCharacteristicsCristalisForm)
      .generate(entity, {
        sessionConsultant: !!user?.sessionConsultant,
        isCristalisOrganization: this.isCristalisOrganization,
      }).valid;
  };
  getSignatureElectronic(entity) {
    return this.injector.get(SignatureElectronic).generate(entity).valid;
  }
  private hasCertifiedSignature(pledge: PledgeRead) {
    return pledge?.products?.some(p => p?.parameters?.signatureCertified);
  }
  getDocument(entity: PledgeRead) {
    if (!this.hasCertifiedSignature(entity)) return true;
    const cniId = entity?.owners.find(owner => owner.gedCniId);
    const passportId = entity?.owners.find(owner => owner?.gedPassportId);
    const result = cniId || passportId;
    return result ? true : false;
  }
  getJustificatifDomicile(entity: PledgeRead) {
    return entity?.parameters?.proofOfAddressId ? true : false;
  }
  getJustificatifOrigineDesFonds(entity: PledgeRead) {
    return entity?.parameters?.proofOfFundsOriginIds &&
      entity?.parameters?.proofOfFundsOriginIds?.length > 0
      ? true
      : false;
  }
  getAssessmentAssets(entity: PledgeRead) {
    const { patrimonyRepartition } = entity?.parameters || {};
    const amount = _.pick({ ...patrimonyRepartition }, [
      'realEstateInvestment.percent',
      'liquidity.percent',
      'professionalAssets.percent',
      'realEstateUse.percent',
      'financialAssets.percent',
    ]);

    return (
      this.floored(
        _.chain(_.sum(_.values(amount).map((el: any) => +el.percent))).value(),
      ) == 1
    );
  }
  getAssessmentAssetsOrigin(entity: PledgeRead) {
    const { patrimonyOriginRepartition } = entity?.parameters || {};
    const amount = _.pick({ ...patrimonyOriginRepartition }, [
      'personally.percent',
      'family.percent',
      'companyOrGroupOrAssociation.percent',
    ]);

    return (
      this.floored(
        _.chain(_.sum(_.values(amount).map((el: any) => +el.percent))).value(),
      ) == 1
    );
  }
  getAssessmentAssetsIncome(entity: PledgeRead) {
    const { earningsRepartition } = entity?.parameters || {};
    const amount = _.pick({ ...earningsRepartition }, [
      'salaryOrRetirement.percent',
      'propertyIncome.percent',
      'movableIncome.percent',
      'bicIncome.percent',
      'bncIncome.percent',
      'baIncome.percent',
    ]);

    const result = this.floored(
      _.chain(_.sum(_.values(amount).map((el: any) => +el?.percent))).value(),
    );

    return result == 1;
  }
  getAssessmentAssetsIncomeServiceDelivery(entity: PledgeRead) {
    const { earningsRepartition } = entity?.parameters || {};
    const amount = _.pick({ ...earningsRepartition }, [
      'salaryOrRetirement.percent',
      'propertyIncome.percent',
      'bicIncome.percent',
      'movableIncome.percent',
      'bncIncome.percent',
      'baIncome.percent',
    ]);

    const result = this.floored(
      _.chain(_.sum(_.values(amount).map((el: any) => +el?.percent))).value(),
    );

    return result == 1;
  }
  floored(value) {
    return Math.round(value * 100) / 100;
  }
}
